// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PartnerScoreAssetHelper from "../../../domain/helper/PartnerScoreAssetHelper.bs.js";
import * as PartnerScoreV2CssHelper from "../../../domain/helper/PartnerScoreV2CssHelper.bs.js";

function SliderTrackMilestoneCmp(Props) {
  var track_thresholds = Props.track_thresholds;
  var current_score = Props.current_score;
  var max_score = Props.max_score;
  var action_details = Props.action_details;
  var index = Props.index;
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "slider-track-milestone-icon",
                  style: {
                    left: PartnerScoreV2CssHelper.getMilestoneIconPosition(index, track_thresholds.length),
                    position: "relative",
                    animationDirection: "alternate",
                    animationDuration: "0.5s",
                    animationIterationCount: "infinite",
                    animationName: PartnerScoreV2CssHelper.getMilestoneIconAnimationName(action_details.action_threshold, index, track_thresholds, action_details.active_suspension),
                    transformOrigin: "bottom"
                  }
                }, PartnerScoreAssetHelper.getMilestoneIcon(current_score, max_score, index, track_thresholds, action_details.active_suspension, action_details.action_threshold)), React.createElement("div", {
                  className: "slider-track-milestone",
                  style: {
                    background: PartnerScoreV2CssHelper.getMilestoneBackgroundColor(current_score, max_score, index, track_thresholds, action_details.active_suspension),
                    left: PartnerScoreV2CssHelper.getMilestonePosition(index, track_thresholds.length),
                    animationDirection: "alternate",
                    animationDuration: "0.5s",
                    animationIterationCount: "infinite",
                    animationName: PartnerScoreV2CssHelper.getMilestoneAnimationName(action_details.action_threshold, index, track_thresholds, action_details.active_suspension),
                    transformOrigin: "bottom"
                  }
                }));
}

var make = SliderTrackMilestoneCmp;

export {
  make ,
  
}
/* react Not a pure module */
